import React, { createContext, useState, useContext, useEffect } from 'react';
import routes from './utils/paths';
import Loader from './Views/Loader';

// Crea el contexto
const AuthContext = createContext();

// Proveedor del contexto
export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [user, setUser] = useState(null);
    const [loginError, setLoginError] = useState('');
    const [loaded, setIsLoaded] = useState(false);

    const logout = () => {
        setIsLoggedIn(false);
        sessionStorage.removeItem('user');
    };


    const login = (user, password) => {
        if (!user.trim() || !password.trim()) {
            setLoginError('Por favor, complete todos los campos');
            return;
        }
        setLoginError('');
        let data = {
            email: user,
            password: password,
        };
        validateData(data);
    };

    async function validateToken() {
        if (sessionStorage.getItem('user')) {
            let token = sessionStorage.getItem('user');
            console.log(token)
            await fetch(routes.domain.url + routes.apis.validate_token, {
                method: 'GET', // El método HTTP es GET
                headers: {
                    'Content-Type': 'application/json',  // Define el tipo de contenido que estás enviando
                    'Authorization': 'Bearer ' + token  // Aquí agregas tu Bearer token
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Error en la respuesta de la API');
                    }
                    return response.json();  // Convertir la respuesta a formato JSON
                })
                .then((responseJson) => {
                    setUser(responseJson);
                    console.log('Datos obtenidos:', responseJson.nick_name);  // Usar los datos obtenidos
                    setIsLoggedIn(true);
                    if (!responseJson.is_guest) {
                        sessionStorage.setItem('user', responseJson.token);
                    }
                    setIsLoaded(true);
                    return;
                })
                .catch((error) => {
                    console.error('Error al obtener los datos:', error);  // Manejo de errores
                    setIsLoaded(true);
                });

            return;
        } else {
            setIsLoaded(true);
            setIsLoggedIn(false);
        }

    }

    const validateData = (data) => {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        };
        fetch(routes.domain.url + routes.apis.login, requestOptions)
            .then(response => {
                return response.json(); // Convierte la respuesta a texto
            })
            .then(responseJson => {

                console.log(responseJson.message);
                if (responseJson.success === false) {
                    setLoginError(responseJson.message)
                } else {
                    setUser(responseJson);
                    if (!responseJson.is_guest) {
                        sessionStorage.setItem('user', responseJson.token);
                    }
                    sessionStorage.setItem('is_guest', responseJson.is_guest ? 1 : 0);
                    if (responseJson.is_guest) {
                        sessionStorage.setItem('guest', responseJson.guest_id);
                    }
                    console.log("", responseJson);
                    setIsLoggedIn(true);
                }
            })
            .catch(error => {
                console.error('Error al realizar la petición:', error);
            });

    }
    useEffect(() => {
        validateToken(); // Se ejecuta al montar
    
        return () => {
            console.log("Saliendo del componente");
            //get out from the view
        };
    }, []); 
    return (

        <div>
            {loaded ? (
                <AuthContext.Provider value={{ isLoggedIn, login, logout, loginError, user }}>
                    {children}
                </AuthContext.Provider>
            ) : (
                <Loader /> // Si no, muestra Login y pasa la función login como prop
            )}
        </div>

    );
};

// Hook para usar el contexto
export const useAuth = () => useContext(AuthContext);
